"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campoli-del-monte-taburno": {
    "76807a4d": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-san-nicola-vecchio": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fd57f4a": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-ornito": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55e9a040": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "cantaro": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f92a302a": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "grieci": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "448cdf36": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "liberia": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a9bccb6": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "martini": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2117c2d": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "pantanelle": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "705c4717": [{
      "hkey": "1c4b0ac3",
      "slug": "pantanielli",
      "name": "Pantanielli",
      "primary": true,
      "skipSearch": false
    }],
    "pantaniello": [{
      "hkey": "1c4b0ac3",
      "slug": "pantanielli",
      "name": "Pantanielli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1d702753": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "pietra-di-tocco": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8dd3b58": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "trivella": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e460840": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "skipSearch": false
    }],
    "velarda": [{
      "hkey": "1572a15c",
      "slug": "campoli-del-monte-taburno",
      "name": "Campoli del Monte Taburno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;